import { useParams } from '@xing-com/crate-core-router';

import { SubtopicPage as Subtopic } from './subtopic-page';

export const Component: React.FC = () => {
  const { topicKey } = useParams();

  return <Subtopic {...{ topicKey }} />;
};
